export default "__VITE_ASSET__BnqqqO_0__"